// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-text {
  color: #382738;
  font-size: 12px;
  font-weight: bold;
}

.arrow-container {
  float: right;
}

.last-saved {
  background-color: #F7F7F8;
}

.team-name-div {
  font-size: 18px;
  font-weight: bold;
  color: #37003C;
  margin-left: 0px !important;
}

.info-text-block {
  float: left;
  margin-left: 0;
}

.form-group {
  margin-bottom: 0;
}

.title-name {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/app/components/club-interview-details/club-interview-header/club-interview-header.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAMA;EACI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AAHJ;;AAMA;EACI,WAAA;EACA,cAAA;AAHJ;;AAMA;EACI,gBAAA;AAHJ;;AAKA;EACI,YAAA;AAFJ","sourcesContent":[".status-text {\n    color: #382738;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.arrow-container {\n    float: right;\n}\n\n.last-saved {\n    background-color: #F7F7F8;\n}\n\n.info-img {\n    //margin-left: 6px;\n}\n\n.team-name-div {\n    font-size: 18px;\n    font-weight: bold;\n    color: #37003C;\n    margin-left: 0px !important;\n}\n\n.info-text-block {\n    float: left;\n    margin-left: 0;\n}\n\n.form-group {\n    margin-bottom: 0;\n}\n.title-name {\n    color: black;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
